import * as React from "react";
import { DeviceData } from "../models/DeviceData";
import { isSingleDevice, tagNameDelimiter } from "../helpers";

interface Props {
    x: string;
    y: string;
    fontSize: string;
    device?: DeviceData;
}

const DeviceInfo = (props: Props) => {
    let tagName = "";
    let pfdAverageDisplay = "";
    let strDisplay = "";
    let ti = "";
    if (props.device != null && props.device.ptProtectiveFunction != null && props.device.ptProtectiveFunction.stR1Year != null) {
        const ptProtectiveFunction = props.device.ptProtectiveFunction;
      if (isSingleDevice(props.device.ptProtectiveFunction.voting)) {
        tagName = ptProtectiveFunction.tageName;
      } else {
        tagName = ptProtectiveFunction.tageName.split(tagNameDelimiter)[0];
      }
      if (tagName && tagName.length >= 9) {
        tagName = tagName.slice(0, 4) + ".." + tagName.slice((tagName.length - 2), tagName.length);
      }
      pfdAverageDisplay = `P:${ptProtectiveFunction.pfdAverageDisplay != null ? ptProtectiveFunction.pfdAverageDisplay : ''}`;
      strDisplay = `S:${ptProtectiveFunction.strDisplay != null ? ptProtectiveFunction.strDisplay : ''}`;
        ti = `TI:${ptProtectiveFunction.proofTestingInterval ?? ""}`;
    }


    return (
        <div style={{ zIndex: 1000, fontSize: props.fontSize, left: props.x, top: props.y, position: "absolute", pointerEvents: "all" }}>
            <span className="label_device">{tagName}</span>
            <span className="label_device">{pfdAverageDisplay}</span>
            <span className="label_device">{strDisplay}</span>
            <span className="label_device">{ti}</span>
        </div>
    );
}

export default DeviceInfo;